import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useUpdateVideoEmbedPostMutation = createMutationHook(
  MembershipsCreatorApiClient.updateVideoEmbedPost,
  {
    mutationKey: ['updateVideoEmbedPost'],
  },
)
